var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable prettier/prettier */
/**
 * 组织架构tab 数据列表
 */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import UserSelectionContext from '../context';
import TabPaneListItem from './TabPaneListItem';
import Loading from '../../Loading';
import { groupListItem, LetterHeader, mapGroupUserInfo, selectContactTypeListItem, selectGroupTypeListItem, } from '../common';
import { Empty, List } from 'antd';
import SelectAll from './SelectAll';
import { useLoadingProps } from '../hooks';
import arrowRightIcon from '../../images/app_ic_arrow_right.png';
import returnIcon from '../../images/app_btn_nb_return.png';
function GroupDeptList(props) {
    var t = React.useContext(UserSelectionContext).t;
    var onGroupClick = props.onGroupClick, GroupItemData = props.GroupItemData, onItemSelect = props.onItemSelect;
    var getItemData = useCallback(function (subGroupInfo) {
        var id = subGroupInfo.id, name = subGroupInfo.name, rosterSize = subGroupInfo.rosterSize, avatar = subGroupInfo.avatar, isGroup = subGroupInfo.isGroup, kind = subGroupInfo.kind, groupId = subGroupInfo.groupId, groupName = subGroupInfo.groupName, subKind = subGroupInfo.subKind;
        var itemData = __assign(__assign({}, subGroupInfo), { id: id,
            name: name,
            avatar: avatar, desc: rosterSize + t('userSelection.people'), isGroup: isGroup,
            kind: kind,
            subKind: subKind,
            groupId: groupId,
            groupName: groupName });
        return itemData;
    }, [t]);
    var getExtraPart = useCallback(function (item) {
        return (React.createElement("span", { className: "focus-user-selection-dept-arrow", onClick: function (event) {
                onGroupClick(item);
                event.stopPropagation();
            } },
            React.createElement("img", { src: arrowRightIcon, alt: "" })));
    }, [onGroupClick]);
    return (React.createElement("div", { className: "" }, (GroupItemData || []).length === 0 ? (React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u6682\u65E0\u6570\u636E" })) : (GroupItemData.map(function (item, key) {
        return (React.createElement(TabPaneListItem, { key: key, data: getItemData(item), extra: getExtraPart(item), onCheckChange: function (groupItem) {
                onItemSelect(groupItem);
            }, onClick: function () {
                onGroupClick(item);
            } }));
    }))));
}
function GroupUserList(props) {
    var _a = React.useContext(UserSelectionContext), defaultUserAvatar = _a.defaultUserAvatar, single = _a.single;
    var dataList = props.dataList, onItemSelect = props.onItemSelect;
    var loadingProps = useLoadingProps(dataList);
    var letterItemsMap = useMemo(function () {
        if (!dataList || (dataList || []).length === 0) {
            return {};
        }
        return groupListItem(dataList);
    }, [dataList]);
    return (React.createElement("div", null, (dataList || []).length === 0 ? (React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u6682\u65E0\u6570\u636E" })) : (React.createElement("div", { className: "groups-user-list" }, Object.keys(letterItemsMap).length > 0 &&
        Object.keys(letterItemsMap).map(function (letter) {
            return (React.createElement("div", { key: letter },
                React.createElement(LetterHeader, { title: letter }),
                React.createElement(List, { loading: loadingProps, dataSource: letterItemsMap[letter] || [], renderItem: function (item) {
                        return (React.createElement(TabPaneListItem, { disabled: item.disabled, key: item.id, defualtImg: defaultUserAvatar, data: item, single: single, checkable: true, onCheckChange: function (item) {
                                onItemSelect(item);
                            } }));
                    } })));
        })))));
}
export default function GroupList(props) {
    var _this = this;
    var _a = React.useContext(UserSelectionContext), currentUser = _a.currentUser, frozenIds = _a.frozenIds, contactShowType = _a.contactShowType, selectGroupType = _a.selectGroupType, dataListFilter = _a.dataListFilter;
    var result = props.result, onItemCheck = props.onItemCheck, onGetGroupData = props.onGetGroupData, onGetGroupMembersData = props.onGetGroupMembersData, jumpCurrentGroupItem = props.jumpCurrentGroupItem, tabKey = props.tabKey;
    var _b = useState([]), GroupItemData = _b[0], setGroupItemData = _b[1];
    var _c = useState([]), GroupMembersData = _c[0], setGroupMembersData = _c[1];
    var _d = useState([]), ItemGroup = _d[0], setItemGroup = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState(true), isShowGroup = _f[0], setIsShowGroup = _f[1];
    var _g = useState(null), err = _g[0], setErr = _g[1];
    var fetchDataList = React.useCallback(function () {
        if (!onGetGroupData) {
            return;
        }
        if (tabKey !== 'group') {
            setItemGroup([]);
            setIsShowGroup(true);
            return;
        }
        setLoading(true);
        onGetGroupData()
            .then(function (groupResult) {
            setErr(null);
            if (selectGroupType) {
                var list = selectGroupTypeListItem(selectGroupType, groupResult);
                setGroupItemData(list);
            }
            else {
                setGroupItemData(groupResult);
            }
        })
            .catch(function (e) {
            setErr(e);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [onGetGroupData] // eslint-disable-line
    );
    var GroupMembersDataList = React.useCallback(function (groupId) {
        if (!onGetGroupMembersData) {
            return;
        }
        setLoading(true);
        onGetGroupMembersData(groupId)
            .then(function (groupMembersResult) {
            setErr(null);
            setGroupMembersData(groupMembersResult);
        })
            .catch(function (e) {
            setErr(e);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [onGetGroupMembersData] // eslint-disable-line
    );
    var deptClick = useCallback(function (item) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setItemGroup(item);
                    setIsShowGroup(false);
                    return [4 /*yield*/, GroupMembersDataList(item.id)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [GroupMembersDataList]);
    useEffect(function () {
        if (jumpCurrentGroupItem) {
            deptClick(jumpCurrentGroupItem);
        }
        fetchDataList();
    }, [deptClick, fetchDataList, jumpCurrentGroupItem]);
    var dataList = useMemo(function () {
        var list = mapGroupUserInfo(GroupMembersData || [], ItemGroup, result, frozenIds);
        list = selectContactTypeListItem(contactShowType, list, currentUser);
        if (dataListFilter) {
            list = list.filter(dataListFilter);
        }
        return list;
    }, [GroupMembersData, ItemGroup, result, frozenIds, contactShowType, currentUser, dataListFilter]);
    var comp;
    if (loading) {
        comp = React.createElement(Loading, { style: { height: '100%' } });
    }
    else if (err) {
        comp = React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u6682\u65E0\u6570\u636E" });
    }
    else {
        comp = (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "group-user-container" },
                !isShowGroup && (React.createElement("p", { className: "group-allSelect" },
                    React.createElement("span", { onClick: function () {
                            // fetchDataList()
                            setIsShowGroup(true);
                        } },
                        React.createElement("img", { src: returnIcon, alt: "" }),
                        "\u00A0",
                        React.createElement("span", null, "\u8FD4\u56DE")))),
                React.createElement("div", { className: "group-users-list" },
                    !isShowGroup && React.createElement(SelectAll, { dataList: dataList || [], result: result }),
                    isShowGroup ? (React.createElement(GroupDeptList, { onItemSelect: function (dept) {
                            onItemCheck(dept);
                        }, result: result, onGroupClick: deptClick, GroupItemData: GroupItemData || [] })) : (React.createElement(GroupUserList, { onItemSelect: function (user) {
                            onItemCheck(user);
                        }, dataList: dataList || [] }))))));
    }
    return React.createElement("div", { className: "groups-container" }, comp);
}
//# sourceMappingURL=GroupList.js.map